import { render } from "./SidebarWrapper.vue?vue&type=template&id=8e51e184&ts=true"
import script from "./SidebarWrapper.vue?vue&type=script&lang=ts"
export * from "./SidebarWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__